<template>
  <div>
   <el-row :gutter="20">
      <el-col :span="6">
        <div class="mt-chome-single">
          <div class="mt-chome-single-name">分佣订单数量（笔）</div>
          <div class="mt-chome-single-num">{{headerInfo.orderNum}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mt-chome-single">
          <div class="mt-chome-single-name">分佣总金额（元）</div>
          <div class="mt-chome-single-num">¥ {{headerInfo.totalTwoCommissionTotalMoney}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mt-chome-single">
          <div class="mt-chome-single-name">分佣现金金额（元）</div>
          <div class="mt-chome-single-num">¥ {{headerInfo.totalTwoCommissionCashMoney}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mt-chome-single">
          <div class="mt-chome-single-name">分佣余额金额（元）</div>
          <div class="mt-chome-single-num">¥ {{headerInfo.totalTwoCommissionMoney}}</div>
        </div>
      </el-col>
    </el-row>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div class="">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="订单搜索：">
              <el-input v-model="searchForm.name" placeholder="请输入订单号/用户昵称/手机号搜索" class="mt-search-width"></el-input>
            </el-form-item>
            <el-form-item label="下单时间筛选：">
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="是否入账：">
              <el-select v-model="searchForm.status" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in statusArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="代理渠道：">
              <el-select v-model="searchForm.agentChannelId" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in agentChannelIdArr"
                  :key="item.id"
                  :label="item.agentChannelName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分公司：">
              <el-select v-model="searchForm.enterpriseId" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in enterpriseIdArr"
                  :key="item.id"
                  :label="item.enterpriseName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="一级(全职)：">
              <el-select v-model="searchForm.firstUserId" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in firstUserIdArr"
                  :key="item.userId"
                  :label="item.nickName"
                  :value="item.userId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级(推广者)：">
              <el-select v-model="searchForm.twoUserId" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in twoUserIdArr"
                  :key="item.userId"
                  :label="item.nickName"
                  :value="item.userId">
                </el-option>
              </el-select>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
              <el-button @click="exportExcelBtn" v-loading.fullscreen.lock="fullscreenLoading">数据导出</el-button>
              <el-button type="primary" style="margin-left: 12px;" @click="clearSearchBtn">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div>
        <el-table
          :data="infoList"
          style="width: 100%">
          <el-table-column
            align="center"
            prop="orderNo"
            label="订单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="statusText"
            label="佣金状态">
          </el-table-column>
          <el-table-column
            align="center"
            prop="realPayMoney"
            label="订单金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="agentChannelName"
            label="代理渠道">
          </el-table-column>
          <el-table-column
            align="center"
            prop="enterpriseName"
            label="分公司">
          </el-table-column>
          <el-table-column
            align="center"
            prop="firstNickName"
            label="一级(全职)">
          </el-table-column>
          <el-table-column
            align="center"
            prop="twoNickName"
            label="二级（推广者）">
          </el-table-column>
          <el-table-column
            align="center"
            prop="twoCommissionTotalMoney"
            label="二级分润总金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="twoCommissionCashMoney"
            label="现金构成金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="twoCommissionMoney"
            label="余额构成金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="moveCostFee"
            label="运费成本">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="下单时间">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryUserCommissionOrderStatisticsPageList, queryFirstUserCommissionUserList, queryTwoUserCommissionUserList, queryUserCommissionLogStatistics, exportExcel, queryAllAgentChannelList } from '@/api/commission'
import { queryEnterprisePageList } from '@/api/user'
export default {
  name: 'ReportForm',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      searchForm: {
        name:'',
        status:'',
        deliveryType:'',
        date:['', ''],
        firstUserId:'',
        enterpriseId:'',
        agentChannelId:'',
        twoUserId:'',
      },
      statusArr:[{
        value:2,
        label:'待入账'
      }, {
        value:3,
        label:'已入账'
      }],
      firstUserIdArr:[],
      enterpriseIdArr:[],
      agentChannelIdArr:[],
      twoUserIdArr:[],
      limitLength: this.$limitLength,
      pageTotal: 0,
      infoList:[],
      currentPage: 1,
      infoId:'',
      headerInfo:{
        orderNum:0,
        totalTwoCommissionTotalMoney:'0.00',
        totalTwoCommissionCashMoney:'0.00',
        totalTwoCommissionMoney:'0.00'
      }
    }
  },
  mounted () {
    var that = this;
    that.getInfoList();
  },
  created() {
    this.headerInfoFun();
    this.enterpriseIdArrFun();
    this.agentChannelIdArrFun();
    this.firstUserIdArrFun();
    this.twoUserIdArrFun();
  },
  methods: {
    // 头部数据
    headerInfoFun(){
      var that = this;
      queryUserCommissionLogStatistics({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.headerInfo = data
        }
      })
    },
    // 导出操作
    exportExcelBtn(){
      var that = this;
      let status = that.searchForm.status
      let searchName = that.searchForm.name
      let firstUserId = that.searchForm.firstUserId
      let enterpriseId = that.searchForm.enterpriseId
      let twoUserId = that.searchForm.twoUserId
      let page = that.currentPage
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      exportExcel({ webCommissionSearchStr: searchName, status: status, startDate: startDate, endDate: endDate, firstUserId: firstUserId, enterpriseId: enterpriseId, twoUserId: twoUserId }).then((res) => {
          // 处理二进制数据并创建 Blob 对象
          const blobObj = new Blob([res], { type: 'application/octet-stream' });
          // 创建一个链接并设置下载属性
          const downloadLink = document.createElement("a");
          let url = window.URL || window.webkitURL || window.moxURL; // 兼容不同浏览器的 URL 对象
          url = url.createObjectURL(blobObj);
          downloadLink.href = url;
          downloadLink.download = '分销报表列表'+new Date().getTime()+'.xlsx'; // 设置下载的文件名
          // 将链接添加到 DOM 中，模拟点击
          document.body.appendChild(downloadLink);
          downloadLink.click();
          // 移除创建的链接和释放 URL 对象
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);
      })
    },
    // 订单列表-获取分公司
    enterpriseIdArrFun(){
      var that = this;
      queryEnterprisePageList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.enterpriseIdArr = data
        }
        if (res.errorCode === '4002') {
          that.enterpriseIdArr = []
        }
      })
    },
    // 订单列表-获取代理渠道
    agentChannelIdArrFun(){
      var that = this;
      queryAllAgentChannelList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.agentChannelIdArr = data
        }
        if (res.errorCode === '4002') {
          that.agentChannelIdArr = []
        }
      })
    },
    // 订单列表-获取一级
    firstUserIdArrFun(){
      var that = this;
      queryFirstUserCommissionUserList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.firstUserIdArr = data
        }
        if (res.errorCode === '4002') {
          that.firstUserIdArr = []
        }
      })
    },
    // 订单列表-获取二级
    twoUserIdArrFun(){
      var that = this;
      queryTwoUserCommissionUserList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.twoUserIdArr = data
        }
        if (res.errorCode === '4002') {
          that.twoUserIdArr = []
        }
      })
    },
    /* 搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 重置操作
    clearSearchBtn(){
      var searchForm = {
        name:'',
        status:'',
        deliveryType:'',
        date:['', ''],
        firstUserId:'',
        enterpriseId:'',
        twoUserId:'',
      }
      this.searchForm = searchForm;
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let status = that.searchForm.status
      let searchName = that.searchForm.name
      let firstUserId = that.searchForm.firstUserId
      let enterpriseId = that.searchForm.enterpriseId
      let twoUserId = that.searchForm.twoUserId
      let page = that.currentPage
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      queryUserCommissionOrderStatisticsPageList({ webCommissionSearchStr: searchName, status: status, startDate: startDate, endDate: endDate, firstUserId: firstUserId, enterpriseId: enterpriseId, twoUserId: twoUserId, pageNum: page, pageSize: that.limitLength }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/commission/ReportForm.vue